import React from 'react';

import styles from './styles';

import { DescriptionListDefault, Divider } from '@cobliteam/base-components';

import Button from '@cobliteam/ui/components/Button';

// @ts-ignore
import { ReactComponent as Icon } from '../../resources/start_icon.svg';

interface StartModuleProps {
  onClose: () => void;
  onContinue: () => void;
}

const StartModule = ({ onClose, onContinue }: StartModuleProps) => (
  <>
    <div className={styles.contentWrapper}>
      <Icon />
      <DescriptionListDefault>
        Gostaríamos de ouvir a sua opinião sobre os dados fornecidos pela Cobli.
      </DescriptionListDefault>
      <DescriptionListDefault>
        Clique em ”continuar” e nos envie sua resposta
      </DescriptionListDefault>
    </div>
    <Divider />
    <div>
      <div className={styles.buttonSection}>
        <Button variant='text' type='button' onClick={onClose}>
          Cancelar
        </Button>
        <Button variant='contained' type='button' onClick={onContinue}>
          Continuar
        </Button>
      </div>
    </div>
  </>
);

export default StartModule;
